import { BUDGET_ALLOCATION_DETAILS } from '../configs/budgetAllocation'
import { useCustomizeStore } from '../stores/customizeStore'

/** `configs/budgetAllocation.ts:265` — the Campaign page-tab's section, the one carrying the rail. */
const CAMPAIGN_SECTION_ID = '6-campaign-breakdown'

/** `composables/useSectionSelections.ts:26` — the cache kind the rail hydrates from. */
const SELECTIONS_KIND = 'sectionSelectionsV1'

/**
 * Preselect one Budget Allocation channel on the Campaign section.
 *
 * The name is validated against the live rail rather than trusted: an unknown or misspelled channel
 * would otherwise write a cache entry the rail silently discards (`tabs.find` misses, so it falls
 * back to the first tab), turning a wiring mistake into a no-op nobody notices. Returns whether the
 * channel was recognised so a caller can assert it.
 */
export function preselectBudgetAllocationChannel(channel: string): boolean {
  const known = BUDGET_ALLOCATION_DETAILS.some((detail) => detail.name === channel)
  if (!known) return false
  useCustomizeStore().setCached(CAMPAIGN_SECTION_ID, SELECTIONS_KIND, {
    version: 1,
    tab: channel,
  })
  return true
}
